<template>
<w-settings-content-template>
  <div slot="content">
    <el-row type="flex" style="height: 100%;">
      <el-col :span="11" style="height: 100%;">
        <div :class="[$style['physical-tree-wrapper'], 'mr-r30']" style="width: 100%; height: 100%;">
          <div style="width:100%; height: 670px;">
            <w-root-cause-physical-obj-table style="height: 100%;" :managetype-data="managetypeData" :checked-obj-list="objList" :fit-height="true" ref="physicalObjTable"></w-root-cause-physical-obj-table>
          </div>
        </div>
      </el-col>
      <el-col :span="2">
        <el-row class="vertical-center-box" style="height:100%;" type="flex" justify="center" align="center">
          <el-button icon="el-icon-arrow-right" style="width: 45px; height: 45px;" :disabled="!(currentSelectedFlag && objList.length > 0)" @click="onClickRegistDevice"></el-button>
        </el-row>
      </el-col>
      <el-col :span="11" class="root-class-event">
        <el-row type="flex" justify="space-between">
          <div>
            <div :class="[$style['root-cause-title'], 'mr-r15']">장애 연관 관계</div>
            <el-button :disabled="(!currentSelectedFlag) || modifiedFlag" @click="onDeleteRootCause">삭제</el-button>
          </div>
          <div class="vertical-center-box" style="margin-bottom: 12px;">
            <el-button class="mr-r5" :disabled="!modifiedFlag" @click="onSaveRootCause">저장</el-button>
            <el-button class="mr-r5" @click="onCancelRootCause">취소</el-button>
            <w-search-field ref="searchField" width="190px" @search="onKeywordSearch" />
          </div>
        </el-row>
        <div class="root-cause-tree">
          <div class="header">
            <div class="cell" style="width:calc(100% - 273px)">
              대상
            </div>
            <div class="cell" style="text-align:center; width:130px;">
              이벤트 예외
            </div>
            <div class="cell" style="text-align:center; width:130px;">
              알람 예외
            </div>
          </div>
          <div style="height: 601px;">
            <el-scrollbar class="bar-visible">
              <el-tree style="height: 100%;" v-loading="isLoading" v-if="!reloadFlag" :data="treeData" class="tree-checkbox" :load="loadData" :ref="treeRef" :props="defaultProps" default-expand-all
                :filter-node-method="filterNode" :node-key="defaultProps.treeKey" :expand-on-click-node="false" highlight-current @current-change="onTreeSelectChange">
                <span class="el-tree-node__label custom-tree-node" slot-scope="{ node, data }">
                  <el-row style="width:100%;" type="flex" justify="space-between" class="root-cause-select-div">
                    <div>{{data.label}}</div>
                    <div v-if="data.node !== 'root'">
                      <el-checkbox true-label="Y" false-label="N" v-model="data.eventExceptFlag" :disabled="data.parentObjId > 0" @change="onChangeCheckFlag('event', data, ...arguments)" style="width: 124px;"></el-checkbox>
                      <el-checkbox true-label="Y" false-label="N" v-model="data.alarmExceptFlag" :disabled="data.parentObjId > 0" @change="onChangeCheckFlag('alarm', data, ...arguments)" style="width: 72px;"></el-checkbox>
                    </div>
                  </el-row>
                </span>
              </el-tree>
            </el-scrollbar>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</w-settings-content-template>
</template>

<script>
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import { defaultProps } from '@/constants/tree';
import TreeFilter from '@/mixins/tree/filter';
import WSearchField from '@/components/form/SearchField';
import OperationApi from '@/api/settings/common/operation-settings';
import { cloneDeep, forEach, isNull, isUndefined, differenceWith, isEqual } from 'lodash';
import msgUtil from '@/utils/message';
import WRootCausePhysicalObjTable from './components/RootCausePhysicalObjTable';

export default {
  name: 'WRootCauseEventSettings',
  mixins: [TreeFilter],
  components: {
    WSettingsContentTemplate,
    WSearchField,
    WRootCausePhysicalObjTable,
  },
  props: {
    activeView: String,
  },
  data() {
    return {
      treeRef: 'tree',
      defaultProps,
      treeDataOrigin: [],
      treeData: [{
        label: '전체',
        objId: -1,
        leaf: false,
        node: 'root',
        children: [],
      }],
      isLoading: false,
      keyword: null,
      objList: [],
      reloadFlag: false,
      treeObjList: [],
      treeUpdateList: [],
      currentSelectedFlag: false,
      modifiedFlag: false,
      managetypeData: [
        { managetypeId: 'SMS', managetypeName: '서버' }, { managetypeId: 'NMS', managetypeName: '네트워크' }, { managetypeId: 'FMS', managetypeName: '시설장비' },
        { managetypeId: 'DBMS', managetypeName: '데이터베이스' }, { managetypeId: 'E2E', managetypeName: 'End to End' }, { managetypeId: 'VMS', managetypeName: '가상화 서버' },
      ],
    };
  },
  watch: {
    activeView: {
      handler() {
        if (this.activeView === this.$options.name) {
          this.loadData();
        }
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * Root Cause 연관 관계 트리를 가져온다.
     * @author Song
     */
    loadData() {
      this.treeUpdateList = [];
      this.treeObjList = [];
      this.isLoading = true;
      const params = {
        node: 'root',
      };
      this.setStyleForRootNodeClass('#fff');
      OperationApi.getRootCauseTree(params).then((res) => {
        if (res.data.success) {
          this.treeData[0].children = res.data.children;
          this.treeDataOrigin = cloneDeep(this.treeData);
          this.isLoading = false;
        }
      });
    },
    onKeywordSearch(value) {
      this.keyword = value;
      this.filterTree(value);
    },
    onObjTypeChange(params, columns) {
      this.objTypeParams = {
        params,
        columns,
      };
    },
    /**
     * 하위 연관 관계 children 장비들 모두 상위 장비의 예외를 따라 저장.
     * 아래의 재귀함수를 통해 모든 children이 일괄적용 되도록 한다.
     * @author Song
     */
    setAllChildrenFlag(children, type, value) {
      forEach(children, (item) => {
        if (value === 'Y') {
          item[`${type}ExceptFlag`] = value;
          if (type === 'event') {
            item.alarmExceptFlag = value;
          }
        } else if (value === 'N') {
          item[`${type}ExceptFlag`] = value;
        }
        item.updateFlag = true;
        // leaf가 아니라면 반복을 계속한다.
        if (!item.leaf) {
          this.setAllChildrenFlag(item.children, type, value);
        }
      });
    },
    /**
     * 장애 연관 관계 트리에서 상위 장비의 예외 설정 change 이벤트이다.
     * 상위 장비의 예의 설정이 변경 됨에 따라 하위 장비들도 함께 규칙에 따라 값이 변경되도록 한다.
     * type: event/ alarm, data: row, value: 값
     * @author Song
     */
    onChangeCheckFlag(type, data, value) {
      if (type === 'event') {
        // 이벤트 예외 체크일 경우 알람 예외도 함께 체크되어야 한다.
        if (value === 'Y') {
          if (!data.leaf) {
            data.alarmExceptFlag = value;
            this.setAllChildrenFlag(data.children, type, value);
          } else {
            data.alarmExceptFlag = value;
          }
        } else if (value === 'N') {
          if (!data.leaf) {
            this.setAllChildrenFlag(data.children, type, value);
          }
        }
      } else if (type === 'alarm') {
        if (data.eventExceptFlag === 'Y') {
          this.$nextTick(() => {
            data.alarmExceptFlag = 'Y';
          });
          this.$alert('이벤트가 예외로 설정된 경우 알람 예외 설정을 해제할 수 없습니다.' +
            '(이벤트가 예외로 설정된 경우 알람도 함께 예외 처리됩니다.)', '정보');
        } else if (data.eventExceptFlag === 'N') {
          if (!data.leaf) {
            this.setAllChildrenFlag(data.children, type, value);
          }
        }
      }
      data.updateFlag = true;
      this.modifiedFlag = true;

      // delete data.updateFlag;
      // // 데이터 변화 체크
      // console.log(isEqual(this.tableData, this.tableDataOrigin));
      // if (isEqual(this.tableData, this.tableDataOrigin)) {
      //   console.log('wqeweq');
      //   this.modifiedFlag = false;
      // } else {
      //   data.updateFlag = true;
      //   this.modifiedFlag = true;
      // }
    },
    /**
     * 선택한 관리 대상을 장애 연관 관계에 추가한다.
     * @author Song
     */
    onClickRegistDevice() {
      const selectedNodes = this.$refs.physicalObjTable.getSelection(); // 선택한 대상 리스트
      // 이미 장애 연관 관계 트리에 등록된 장비는 추가로 등록될 수 없다.
      this.treeObjList = [];
      this.getObjListFromTree(this.treeData[0].children);

      const targetNode = this.$refs[this.treeRef].getCurrentNode();
      forEach(selectedNodes, (item) => {
        // 조회한 트리 objId들을 현재 추가할 objId와 비교하여 중복검사 실행
        const duplicateNode = this.treeObjList.findIndex((target) => item.objId === target);
        const targetIp = item.ipaddress ? ` (${item.ipaddress})` : '';
        // 중복이 아닌 대상만 추가할 것
        if (!(duplicateNode >= 0)) {
          const addTreeTarget = [{
            alarmExceptFlag: targetNode.alarmExceptFlag ? targetNode.alarmExceptFlag : 'N',
            eventExceptFlag: targetNode.eventExceptFlag ? targetNode.eventExceptFlag : 'N',
            objId: item.objId,
            parentObjId: targetNode.objId,
            label: `${item.objName} ${targetIp}`,
            leaf: true,
            updateFlag: true,
          }];
          if (targetNode.children) {
            targetNode.children.push(addTreeTarget[0]);
          } else {
            targetNode.children = [];
            targetNode.children.push(addTreeTarget[0]);
            targetNode.leaf = false; // leaf였던 노드에 자식이 생기면서 leaf: false 변경 필요
          }
          this.modifiedFlag = true;
        }
      });
      // modifiedFlag 값이 false 라면 선택한 장비들이 모두 장애 연관 관계에 이미 포함되어 있는 장비들이다.
      if (!this.modifiedFlag) {
        this.$message(msgUtil.getCustomResultMsgData('이미 장애 연관 관계에 등록된 장비입니다.', false));
      }
      // 리로드 및 값 초기화
      this.reloadFlag = true;
      this.$nextTick(() => {
        this.reloadFlag = false;
        this.$refs.physicalObjTable.clearSelection(); // 장비 테이블 체크 해제
        this.objList = []; // 선택한 장비리스트 초기화
        this.currentSelectedFlag = false;
        this.setStyleForRootNodeClass('#fff');
      });
    },
    onTreeSelectChange(data) {
      this.currentSelectedFlag = !isNull(data) && !isUndefined(data);
      if (data.node === 'root') {
        this.setStyleForRootNodeClass('#f1f2f5');
      } else {
        this.setStyleForRootNodeClass('#fff');
      }
    },
    /**
     * 첫번째 노드만 하이라이트 표현되는 문제 및 부모의 노드 클릭 시 자식의 노드도 함께 스타일 적용되는 문제 확인
     * 추후 다른 방법으로 스타일 변경가능하다면 수정 필요
     * @author Song
     */
    setStyleForRootNodeClass(color) {
      this.$nextTick(() => {
        const targetDiv = document.getElementsByClassName('el-tree tree-checkbox el-tree--highlight-current');
        targetDiv[0].children[0].children[0].setAttribute('style', `background-color: ${color} !important;`);
      });
    },
    /**
     * 설정한 장애 연관 관계를 저장한다.
     * @author Song
     */
    onSaveRootCause() {
      // 재귀함수를 이용, 모든 children들을 순회하며 updateFlag가 true인 대상들만을 필터링한다.
      this.getTreeUpateList(this.treeData[0].children);
      OperationApi.updateRootCauseTreeList(this.treeUpdateList).then((res) => {
        if (res.data.success) {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, '장애 연관 장비', true));
          this.loadData();
          this.modifiedFlag = false;
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, '장애 연관 장비', false));
        }
        this.treeUpdateList = [];
      });
    },
    /**
     * 장애 연관 관계 트리에서 업데이트된 대상들을 필터링한다.
     * @author Song
     */
    getTreeUpateList(data) {
      forEach(data, (item) => {
        if (item.updateFlag) {
          this.treeUpdateList.push(item);
        }
        if (!item.leaf) {
          this.getTreeUpateList(item.children);
        }
      });
    },
    /**
     * 장애 연관 관계 트리에서 선택한 대상 장비를 삭제한다. (연관 장비 포함)
     * @author Song
     */
    onDeleteRootCause() {
      const deleteList = this.$refs[this.treeRef].getCurrentNode();
      this.$confirm(...msgUtil.getCustomConfirmData('삭제하시겠습니까? (하위 연관 장비도 함께 삭제됩니다.)')).then(() => {
        OperationApi.deleteRootCauseTreeList(deleteList).then((res) => {
          if (res.data.success) {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '장애 연관 장비', true));
            this.currentSelectedFlag = false;
            this.loadData();
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '장애 연관 장비', false));
          }
        });
      }).catch(() => {});
    },
    onCancelRootCause() {
      this.modifiedFlag = false;
      this.currentSelectedFlag = false;
      this.treeObjList = [];
      this.treeData = cloneDeep(this.treeDataOrigin);
      this.setStyleForRootNodeClass('#fff');
    },
    /**
     * 재귀함수를 통해 트리에 존재하는 모든 objIdList를 찾는다. (트리 추가 시 obj 중복 검사를 위해)
     * @author Song
     */
    getObjListFromTree(item) {
      forEach(item, (targetNode) => {
        this.treeObjList.push(targetNode.objId);
        if (!item.leaf) {
          this.getObjListFromTree(targetNode.children);
        }
      });
    },
  },
};
</script>

<style lang="scss">
.root-class-event .root-cause-tree {
  .header {
    width: 100%;
    border-top: 1px solid #888; //$chinagray
    /* border-bottom: 1px solid #e5e5e5; */
    background: #eee; //$palegray

    .cell {
      display: inline-block;
      color: #6b7079;
      font-weight: 400;
      padding: 5px 15px;
    }
  }

  .el-tree-node__content {
    background-color: #fff;

    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .cell {
      display: inline-block;
    }
  }
}
.root-class-event .tree-checkbox .el-tree-node__content > .el-tree-node__expand-icon {
  display: block;
  margin-left: 8px;
  margin-right: 0px !important;
}
.root-class-event .el-tree-node__children > .el-tree-node.is-current > .el-tree-node__content .is-leaf + .el-tree-node__label {
  color: #333 !important;
  font-weight: 400 !important;
}

.root-cause-tree .is-current {
  background-color: #f1f2f5 !important;
  .el-tree-node {
    background-color: #fff !important;
  }
}
</style>

<style module lang="scss">
.physical-tree-wrapper {
  height: 100%;
  width: calc(65% - 30px);
  float: left;
}
.root-cause-title {
  float: left;
  display: flex;
  align-items: center;
  font-weight: 500;
  color: #000;
  font-size: 1.063rem;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/EventAlarmSettings/RootCauseEventSettings/index.vue